import { select, call, put } from 'redux-saga/effects';
import { updateCQ as updateCQAda } from '@bitComponents/adabyron/cqv2';
import { WEB_SERVICES } from './webServices';
import { maskSeparation } from '@bitComponents/formSkeleton/Input/utils';
import { MASKS } from '../constants/uxConstants';

const contextStore = state => state.context.data;
export const UPDATE_CQ_RISK_ERROR = '415';

const normalizeUpdateCQResponse = (response) => {
  const { requiredAccount, customerAccounts } = response;
  const customerAccountsNormalized = [];

  if (customerAccounts && Array.isArray(customerAccounts)) {
    customerAccounts.forEach((customerAcc) => {
      const {
        bankEntityCode,
        bankOfficeCode,
        ibanCheckDigits,
        ibanCountryIso2Code,
        spanishIbanAccountNumber,
        spanishIbanCheckDigits,
        customerAccountId,
      } = customerAcc;

      const customerAccountNumber = `${ibanCountryIso2Code}${ibanCheckDigits}${bankEntityCode}${bankOfficeCode}${spanishIbanCheckDigits}${spanishIbanAccountNumber}`;
      const customerAccountNumberWithMask = maskSeparation(customerAccountNumber, MASKS.accountNumber.maxLength, MASKS.accountNumber.separationLength, MASKS.accountNumber.separator);
      const newCustomerAccountObj = {
        customerAccountId,
        customerAccountNumber: customerAccountNumberWithMask,
      };

      customerAccountsNormalized.push(newCustomerAccountObj);
    });
  }

  return {
    requiredAccount,
    customerAccounts: customerAccountsNormalized
  };
}

export function* updateCQ(params) {
  const {
    reduxUpdate,
    cqId,
    locationId,
    sms,
    phone,
    POTsChoices,
    riskEvaluation,
    normalizeHttpErrors,
  } = params;

  try {
    const context = yield select(contextStore);
    const { successUpdate } = reduxUpdate;
    const args = {
      cqId,
      sms,
      phone,
    };
    if (locationId) {
      args.locationId = locationId;
    }
    if (Array.isArray(POTsChoices)) {
      args.choices = POTsChoices;
    }
    if (Array.isArray(riskEvaluation)) {
      args.riskEvaluation = riskEvaluation;
    }
    const response = yield call(updateCQAda, args, context);
    if (response
      && response.risk
      && response.risk.code === UPDATE_CQ_RISK_ERROR
      && response.risk.evaluationFormValues
    ) {
      return response;
    }
    const responseNormalized = normalizeUpdateCQResponse(response);
    yield put(successUpdate(responseNormalized));
    return response;
  } catch (error) {
    const { errorUpdate } = reduxUpdate;
    const errorNormalized = yield call(normalizeHttpErrors, WEB_SERVICES.UPDATE_CQ, error);
    if (errorUpdate) {
      yield put(errorUpdate(errorNormalized));
    }

    throw error;
  }
}
